import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MetadataService } from '../../services/metadata.service';
import { RemoteConfigService } from '../../services/remote-config.service';
import { Utils } from '../../services/util.service';
import { VideoThumbSharedComponent } from '../video-thumb-shared/video-thumb-shared.component';
import { Router } from '@angular/router';
import { ChannelsService } from '../../services/channels.service';
import { PlaylistService } from 'src/app/services/playlist.service';

@Component({
    selector: 'app-video-thumb-open',
    templateUrl: './video-thumb-open.component.html',
    styleUrls: ['./video-thumb-open.component.scss']
})
export class VideoThumbOpenComponent extends VideoThumbSharedComponent implements OnInit, OnDestroy {

    constructor(
        private router: Router,
        public readonly channelService: ChannelsService,
        public readonly metadataService: MetadataService,
        public readonly utils: Utils,
        public readonly changeDetector: ChangeDetectorRef,
        public readonly config: RemoteConfigService,
        private playlistService: PlaylistService) {
        super(changeDetector, metadataService, utils, channelService);
    }

    showOptions: boolean = false;
	private holdTimeout: any;
	private isLongPress: boolean = false;
	addToPlaylistLoading: boolean = false;
	focusedElement: string = '';

	@ViewChild('playButton') playButton!: ElementRef;
  	@ViewChild('watchlistButton') watchlistButton!: ElementRef;

    redirectToVideo() {
        this.router.navigate(this.routerLink, {queryParams: {recommendationId: this.recommendationId}});
    }

    handleKeyDown(event: KeyboardEvent): void {
        const key = this.checkXboxKey(event);

		if (key === 'Enter') {
		  if (!this.holdTimeout) {
			this.isLongPress = false;
			this.holdTimeout = setTimeout(() => {
			  this.showOptions = true;
			  this.isLongPress = true;
			  event.preventDefault();
			  event.stopPropagation();
			}, 400);
		  }
		}

		if (this.showOptions && key !== 'Enter') {
			if ((this.focusedElement == 'play' && key == 'ArrowDown') || (this.focusedElement == 'watchlist' && key == 'ArrowUp')) {
                if(this.focusedElement == 'play') {
                    setTimeout(() => {
                        this.watchlistButton.nativeElement.focus();
                    }, 50);
                } else {
                    setTimeout(() => {
                        this.playButton.nativeElement.focus();
                    }, 50);
                }
            } else {
				this.thumb.nativeElement.focus();
				this.showOptions = false;
			}
		}
	}

	handleKeyUp(event: KeyboardEvent): void {
        const key = this.checkXboxKey(event);

		if (key === 'Enter') {
		  if (this.holdTimeout) {
			clearTimeout(this.holdTimeout);
			this.holdTimeout = null;
		  }

		  if (!this.isLongPress && !this.showOptions) {
			this.redirectToVideo();
		  }

		  if (this.showOptions) {
			setTimeout(() => {
				this.playButton.nativeElement.focus();
			}, 10)
		  }
		}
	}

	addToPlaylist(media: any) {
        if (!this.addToPlaylistLoading) {
            this.addToPlaylistLoading = true;
            this.playlistService.addToPlaylist(media).subscribe({
                next: async () => {
                    this.completeWatchlistToggle();
                },
                error: () => {
                    this.completeWatchlistToggle();
                }
            });
        }
    }

    deleteFromPlaylist(media: any) {
        if (!this.addToPlaylistLoading) {
            this.addToPlaylistLoading = true;
            this.playlistService.deleteFromPlaylist(media).subscribe({
                next: async () => {
                    this.completeWatchlistToggle();
                },
                error: () => {
					this.completeWatchlistToggle();
                }
            });
        }
    }

	completeWatchlistToggle() {
		this.addToPlaylistLoading = false;
		setTimeout(() => {
			this.watchlistButton.nativeElement.focus();
		}, 50);
	}

	existsInPlaylist(mediaId: number) {
        return this.playlistService.hasMediaId(mediaId);
    }
}
